import { render, staticRenderFns } from "./lrCompany.vue?vue&type=template&id=213e9530&scoped=true&"
import script from "./lrCompany.vue?vue&type=script&lang=js&"
export * from "./lrCompany.vue?vue&type=script&lang=js&"
import style0 from "./lrCompany.vue?vue&type=style&index=0&id=213e9530&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e9530",
  null
  
)

export default component.exports